import { GenericAbortSignal } from 'axios';
import { AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { ChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import { isCanceledError, useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';
import { BaseChannelAutoComplete, ChannelAutoCompleteProps, ChannelAutoCompleteQueryParams } from "views/knowledge/channels/components/BaseChannelAutoComplete";

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de canais para busca no feed
 * @param props
 */
export const ChannelFeedAutoComplete: React.FC<ChannelAutoCompleteProps> = (props) => {

    const api = useCoreApi();
    const { selectedItems, onChange, onError } = props;

    ///
    const getSuggestions = (p: ChannelAutoCompleteQueryParams, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>> => {
        return new Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>>((resolve) => {
            api.v1.knowledgeSuggestions.feedChannel({
                searchText: p.searchText,
                pageNumber: p.pageNumber,
                pageSize: p.pageSize,
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as ChannelAutoCompleteDataModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <BaseChannelAutoComplete
            {...props}
            onChange={(itens) => onChange(itens as ChannelAutoCompleteDataModel[])}
            selectedItems={selectedItems}
            onGetSuggestions={getSuggestions}
        />
    );
};
